import React, { useState } from "react"
import {
  Button,
  Typography,
  Snackbar,
  Alert,
  Card,
  CardContent,
  CardMedia,
} from "@mui/material"
import { Link } from "react-router-dom"
import { styled } from "@mui/system"

const StyledButton = styled(Button)({
  margin: "10px",
})

const operations = [
  {
    header: "Admin Operations",
    image: "/admin.jpg", // Add your image URL here
    items: [
      { route: "/admin/app-admin/create", label: "Create App Admin" },
      {
        route: "/admin/app-admin/create-event-admin",
        label: "Create Event Admin",
      },
      { route: "/admin/app-admin/manage-admins", label: "Manage Admins" },
      // {
      //   route: "/admins/delete/event-admin",
      //   label: "Coming Soon",
      //   disabled: true,
      // },
    ],
  },
  {
    header: "Event Operations",
    image: "/event.jpg", // Add your image URL here
    items: [
      { route: "/admin/app-admin/event/create", label: "Create Event" },
      { route: "/admin/app-admin/event/edit", label: "Manage Event" },
      //{ route: "/admin/app-admin/event/delete", label: "Delete Event" },
      { route: "/admin/app-admin/event/archive", label: "Archive Event" },
      {
        route: "/admin/app-admin/event/view-archives",
        label: "View Archived Events ",
      },
    ],
  },
]

const NotificationSnackbar = ({
  message,
  onClose,
}: {
  message: string | null
  onClose: () => void
}) => (
  <Snackbar
    open={!!message}
    autoHideDuration={3000}
    onClose={onClose}
    anchorOrigin={{ vertical: "top", horizontal: "right" }}
  >
    <Alert onClose={onClose} severity="success" sx={{ width: "100%" }}>
      {message}
    </Alert>
  </Snackbar>
)

export const AppAdminDashboardPage: React.FC<{ notification?: string }> = ({
  notification = "",
}) => {
  const [snackbarMessage, setSnackbarMessage] = useState<string | null>(
    notification
  )

  const renderButton = (item: any) => (
    <Button
      key={item.route}
      variant="contained"
      color="primary"
      component={Link}
      to={item.route}
      disabled={item.disabled}
      sx={{ margin: "4px" }} // Add margin here to create space between buttons
    >
      {item.label}
    </Button>
  )

  return (
    <>
      <Typography variant="h5" m={4}>
        Application Admin Menu
      </Typography>

      <div style={{ display: "flex", flexWrap: "wrap" }}>
        {operations.map((group, idx) => (
          <Card key={idx} sx={{ margin: "10px", flex: "1 1 300px" }}>
            <CardMedia
              component="img"
              height="200"
              image={group.image}
              alt={group.header}
            />
            <CardContent>
              {group.header && (
                <Typography variant="h6" mb={2}>
                  {group.header}
                </Typography>
              )}
              {group.items.map(renderButton)}
            </CardContent>
          </Card>
        ))}
      </div>

      <NotificationSnackbar
        message={snackbarMessage || ""}
        onClose={() => setSnackbarMessage(null)}
      />
    </>
  )
}
